import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {resendConfirmationEmail} from 'actions/userActions';

import {CONFIRM_EMAIL_MESSAGE, PAID_PLAN_REQUIRED_MESSAGE, RESEND_CONFIRMATION_EMAIL_SUCCESS} from 'constants/messages';

import uiHelper from 'helpers/uiHelper';

import {colors, containerStyles} from 'styles/shared';

const BannerContainer = styled.div`
  height: 6rem;
  padding: 1.5rem;
  margin: 5rem 0 3rem;
  ${containerStyles};
  border-radius: 1.5rem;
  background-color: ${colors.blue_light};
`;

const BannerTitle = styled.div`
  font-size: 2.5rem;
  line-height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Link = styled.div`
  color: ${colors.blue_darker};
  cursor: pointer;
  text-decoration: underline;
  margin-left: 2rem;
`;

Banner.propTypes = {
  pending: PropTypes.bool.isRequired
};

function Banner({pending}) {
  let history = useHistory();
  let dispatch = useDispatch();

  let message = pending ? CONFIRM_EMAIL_MESSAGE : PAID_PLAN_REQUIRED_MESSAGE;

  function redirectToSubscribe() {
    history.push('/subscribe');
  }

  function sendConfirmationEmail() {
    uiHelper.showMessage(RESEND_CONFIRMATION_EMAIL_SUCCESS);
    dispatch(resendConfirmationEmail());
  }

  return (
    <BannerContainer>
      <BannerTitle>
        {message}

        {pending ? (
          <Link onClick={sendConfirmationEmail}>Resend confirmation email</Link>
        ) : (
          <Link onClick={redirectToSubscribe}>Choose plan</Link>
        )}
      </BannerTitle>
    </BannerContainer>
  );
}

export default Banner;
